import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { Marker, InfoBox } from '@react-google-maps/api'
import { buildMarkerSvgBinary } from '../../../components/Shared/SearchResultsMap/utils'
import { useStores } from '../../Hooks'
import CardMapPreview from '../../../components/Shared/SearchResultsMap/CardMapPreview'

const NearbyListing = ({ listing }) => {
  const { store: { mapStore } } = useStores()
  const [isLoading, setLoading] = useState(false)

  const handleSetActive = () => {
    mapStore.getActiveListingDetails(listing, setLoading)
  }

  const handleSetInactive = () => {
    mapStore.setActiveListing({})
  }

  const handleOnSaveClick = e => {
    e.stopPropagation()
    e.preventDefault()
    mapStore.updateSaveStatus(mapStore.activeListing)
  }

  const isCardVisible = () => mapStore.hasActiveListing && mapStore.activeListing.id === listing.id

  return (
    <Marker
      onClick={handleSetActive}
      position={{ lat: +listing.lat, lng: +listing.lon }}
      icon={{ url: buildMarkerSvgBinary({ listing }) }}
    >
      {isCardVisible()
        ? <InfoBox options={{
          boxStyle: { overflow: 'unset' },
          infoBoxClearance: new global.google.maps.Size(10, 10),
          closeBoxURL: '',
          pixelOffset: global.google && new global.google.maps.Size(-93, -287),
          enableEventPropagation: true
        }}>
          <CardMapPreview
            isLoading={isLoading}
            activeItem={mapStore.activeListing}
            handleOnSaveClick={handleOnSaveClick}
            removeMarkAsActive={handleSetInactive}
          />
        </InfoBox>
        : null
      }
    </Marker>
  )
}

NearbyListing.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.number.isRequired,
    lat: PropTypes.number,
    lon: PropTypes.number
  }).isRequired
}

export default observer(NearbyListing)
